import type {ThemeColorSchemeKey} from '@sanity/ui'
import {createContext, useContext} from 'react'

type ThemeToggleContextValue = {
  scheme: ThemeColorSchemeKey
  setScheme: (scheme?: ThemeColorSchemeKey) => void
}

const ThemeToggleContext = createContext<ThemeToggleContextValue | undefined>(undefined)

export function ThemeToggleProvider(props: {
  scheme: ThemeColorSchemeKey
  setScheme: (scheme?: ThemeColorSchemeKey) => void
  children: React.ReactNode
}) {
  const {scheme, setScheme, children} = props
  return (
    <ThemeToggleContext.Provider value={{scheme, setScheme}}>
      {children}
    </ThemeToggleContext.Provider>
  )
}

export function useThemeToggle() {
  const ctx = useContext(ThemeToggleContext)
  if (!ctx) {
    throw new Error('useThemeToggle must be used within ThemeToggleProvider')
  }
  return ctx
}
